import ReportDetailActivityModal from './ReportDetailActivityModal'
import { withReportDetailActivityModal } from './withReportDetailActivityModal'

const ConnectedReportDetailActivityModal = withReportDetailActivityModal(
  ReportDetailActivityModal
)

export { ConnectedReportDetailActivityModal as ReportDetailActivityModal }
